import "./input.scss";
import React, { forwardRef } from "react";
import SearchIcon from "../../../media/icons/search-icon";
import * as styles from "../../styles/Stylesheet.js";

const Input = forwardRef(function Input(
  {
    type = "text",
    value = "",
    onChange,
    onClick,
    onKeyUp,
    label,
    placeholder = "",
    maxLength = 120,
    error,
    explainer,
    reversed,
    disabled,
    search,
    name,
    id,
    className,
    uppercase,
    ...rest
  },
  ref
) {
  const explainerId = explainer ? `${id}-explainer` : undefined;

  const containerClasses = [
    "input-container",
    reversed && "reversed",
    error && "error",
    uppercase && "uppercase",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const inputClasses = ["input", search && "search"].filter(Boolean).join(" ");

  return (
    <div className={containerClasses}>
      {label ? (
        <label className="input-label" htmlFor={id}>
          {label}
        </label>
      ) : null}

      <div className="input-wrapper">
        {search ? (
          <SearchIcon
            color={styles.color_accent}
            className="search-icon"
            aria-hidden="true"
          />
        ) : null}

        <input
          maxLength={maxLength}
          id={id}
          name={name}
          ref={ref}
          type={search ? "search" : type}
          value={value}
          placeholder={placeholder}
          onClick={onClick}
          onKeyUp={onKeyUp}
          onChange={onChange}
          disabled={disabled}
          aria-invalid={!!error || undefined}
          aria-describedby={explainerId}
          className={inputClasses}
          {...rest}
        />
      </div>

      {explainer ? (
        <div id={explainerId} className="input-explainer">
          {explainer}
        </div>
      ) : null}
    </div>
  );
});

export default Input;
